module.exports = __webpack_public_path__ + "media/images/illustrations/unit_sizes/10x25_small-c44fe0595cfc7964672d1c2c2c5e0534.png";